import React, {Component} from 'react';
import {connect} from 'react-redux'
import {locale} from '../../locale/AppLocale'
import axios from 'axios';
import {NotificationManager} from '../../Helpers/NotificationManager';;
import Config from "../../Helpers/Config";
import {
    Field, FieldArray, reduxForm, touch
} from 'redux-form'
import ProductInput from '../../Components/ProductInput'
import Loader from "../../Components/Loader";
import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import isIn from 'validator/lib/isIn';
import isInt from 'validator/lib/isInt';
import isFloat from 'validator/lib/isFloat';
import {FormattedPrice} from "../../Helpers/FormattedPrice";
import {Currencies} from "../../Helpers/Currencies";

let currenciesList = [];

Object.keys(Currencies()).map((currency, index) => {
    currenciesList.push({id: currency, title_ar: Currencies()[currency].title})
});

class InvoiceCreate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submittingForm: false,
            rows: [],
            currency: 'ils',
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.renderInvoiceTable = this.renderInvoiceTable.bind(this);
        this.calculateAmount = this.calculateAmount.bind(this);
    }

    componentDidMount() {
        if (!this.props.auth.business.can_create_invoice) {
            this.props.history.push(`/${this.props.match.params.businessSlug}/orders/`);
        }
    }

    onSubmit(values) {

        this.setState({
            submittingForm: true
        }, () => {
            const data = {};
            axios.post(`${Config.api()}invoice/create/${this.props.auth.business.id}`, values, {
                withCredentials: Config.withCredentials()
            }).then((response) => {
                if (response.data.status) {
                    NotificationManager.success(locale.get('invoice_created_successfully'));
                    this.props.history.push(`/${this.props.match.params.businessSlug}/invoice`);
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                    this.setState({
                        submittingForm: false,
                    });
                }
            }).catch((error) => {
                if (typeof error.response.status !== 'undefined' && error.response.status === 401) {
                    this.props.requiresReLogin();
                } else {
                    NotificationManager.error(locale.get('an_error_occurred_while_initializing_data'));
                    this.setState({
                        submittingForm: false,
                    });
                }
            });
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.auth.business.can_create_invoice === true;
    }

    render() {
        return (
            this.props.auth.business.can_create_invoice && <div>
                <form className="form-horizontal" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this)) }>
                    <div className="panel-1">
                        <div className="panel-1--head bg-white">
                            {locale.get('create_invoice')}
                        </div>
                        <div className="panel-1--body is-full">
                            <Field
                                type="text"
                                name="to_email"
                                id="invoice-to_email"
                                component={ProductInput}
                                className="form-control"
                                label={locale.get('email')}
                                placeholder={locale.get('email')}
                                field={{}}/>
                            <Field
                                type="text"
                                name="receiver"
                                id="invoice-receiver"
                                component={ProductInput}
                                className="form-control"
                                label={locale.get('receiver_name')}
                                placeholder={locale.get('receiver_name')}
                                field={{}}/>
                            <Field
                                type="dropdown"
                                name="currency"
                                id="invoice-receiver"
                                component={ProductInput}
                                className="form-control"
                                label={locale.get('currency')}
                                placeholder={locale.get('currency')}
                                field={{data_type: "dropdown", options: currenciesList}}
                                onChange={(e, value) => {
                                    this.setState({currency: value}, () => {
                                        this.props.dispatch(touch('invoiceForm'));
                                    });
                                }}

                            />
                            <div className="clearfix"/>

                            <FieldArray name="invoice_item" component={this.renderInvoiceTable}/>

                        </div>
                        <div className="clearfix"/>
                        <div className="panel-1--footer">
                            <button className="btn-1" disabled={this.state.submittingForm}><Loader
                                completed={this.state.submittingForm === false}/> {locale.get('create')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    calculateAmount(field) {
        if (field.quantity && !isEmpty(field.quantity) && isInt(field.quantity) && field.price && !isEmpty(field.price) && isFloat(field.price)) {
            const amount = parseInt(field.quantity) * parseFloat(field.price);
            return FormattedPrice(amount, '', this.state.currency);
        }
        return FormattedPrice(0.00, '', this.state.currency);
    }

    renderInvoiceTable({fields, meta: {error, submitFailed}}) {
        return (
            <table className="table">
                <thead>
                <tr>
                    <th>#</th>
                    <th>{locale.get('description')}</th>
                    <th>{locale.get('quantity')}</th>
                    <th>{locale.get('price')}</th>
                    <th>{locale.get('total')}</th>
                    <th/>
                </tr>
                </thead>

                <tbody>
                {fields.map((rowId, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                            <Field
                                type="text"
                                name={`${rowId}.description`}
                                id={`invoice_item-${rowId}-description`}
                                component={ProductInput}
                                className="form-control"
                                label={``}
                                placeholder={locale.get('description')}
                                field={{is_required: true}}/>
                        </td>
                        <td>
                            <Field
                                type="text"
                                name={`${rowId}.quantity`}
                                id={`invoice_item-${rowId}-quantity`}
                                component={ProductInput}
                                className="form-control"
                                label={``}
                                placeholder={locale.get('quantity')}
                                field={{is_required: true}}/>
                        </td>
                        <td>
                            <Field
                                type="text"
                                name={`${rowId}.price`}
                                id={`invoice_item-${rowId}-price`}
                                component={ProductInput}
                                className="form-control"
                                label={``}
                                placeholder={locale.get('price')}
                                field={{is_required: true}}/>
                        </td>

                        <td>{this.calculateAmount(fields.get(index))}</td>

                        <td>
                            <button
                                disabled={fields.length <= 1}
                                className="btn btn-2 btn--small"
                                type="button"
                                onClick={() => fields.length > 1 && fields.remove(index)}
                            >{locale.get('remove')}
                            </button>

                        </td>
                    </tr>
                ))}
                </tbody>
                <tfoot>
                {submitFailed && error && <tr>
                    <td colSpan={6}>
                        <div className="input-c has-error no-mb">
                            <div className="help-block is-error">{error}</div>
                        </div>
                    </td>
                </tr>}
                <tr>
                    <td colSpan={6}>
                        <button type="button" className="btn btn-2 btn--small " onClick={() => fields.push({})}>
                            {locale.get('new_invoice_row')}
                        </button>
                    </td>
                </tr>
                </tfoot>
            </table>
        )
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => ({});

const validateInvoice = (values, props) => {
    let errors = {};

    if (!values.to_email || isEmpty(values.to_email) || !isEmail(values.to_email)) {
        errors.to_email = locale.get('email_is_not_valid');
    }
    if (!values.receiver || isEmpty(values.receiver)) {
        errors.receiver = locale.get('required', {field: locale.get('receiver_name')});
    }
    if (!values.currency || isEmpty(values.currency) || !isIn(values.currency, ['usd', 'ils'])) {
        errors.currency = locale.get('required', {field: locale.get('currency')});
    }
    if (!values.invoice_item || !values.invoice_item.length) {
        errors.invoice_item = {_error: locale.get('invoice_row_is_required')}
    } else {
        errors.invoice_item = {};
        values.invoice_item.map((fields, index) => {

            if (!errors.invoice_item[index]) {
                errors.invoice_item[index] = {};
            }

            if (!fields.description || isEmpty(fields.description)) {
                errors.invoice_item[index].description = locale.get('required', {field: locale.get('description')});
            }

            if (!fields.quantity || isEmpty(fields.quantity)) {
                errors.invoice_item[index].quantity = locale.get('required', {field: locale.get('quantity')});
            } else if (!isInt(fields.quantity)) {
                errors.invoice_item[index].quantity = locale.get('is_not_valid', {field: locale.get('quantity')});
            }

            if (!fields.price || isEmpty(fields.price)) {
                errors.invoice_item[index].price = locale.get('required', {field: locale.get('price')});
            } else if (!isFloat(fields.price)) {
                errors.invoice_item[index].price = locale.get('is_not_valid', {field: locale.get('price')});
            }

        });
    }

    return errors;
};

InvoiceCreate = reduxForm({
    form: 'invoiceForm',
    enableReinitialize: false,
    validate: validateInvoice,
})(InvoiceCreate);

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceCreate);
